import { FindPriceTablesParams } from '../../../../../../../../../services/modules/priceTables/priceTables.types';
import { PriceTable } from '../../../../../../../../price-tables/price-table.types';
import { OfflineDatabasePriceTable } from '../../../../../../../database/offlineDatabase/types/offlineDatabasePriceTable.types';
import { offlinePriceTablesRepository } from '../../../../../../../repositories/offlinePriceTables.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';

export class PriceTablesQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority'>) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    const queryKeysAndFnToBrandAdmin = await generateQueryKeysAndFnToPaginatedEndpoint<
      PriceTable,
      FindPriceTablesParams
    >({
      url: '/price-tables/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlinePriceTablesRepository.saveAll(data.map(this.toOfflineData));
      },
    });

    return queryKeysAndFnToBrandAdmin;
  }

  private toOfflineData(data: PriceTable): OfflineDatabasePriceTable {
    return {
      id: data.id,
      name: data.name,
      code: data.code,
      defaultTable: data.defaultTable,
    };
  }
}
